<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  dialogTitle="Edit Team"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!errorFree() || !form.dirty"
  [guardUnsavedWork]="form.dirty"
  (submit)="handleEditComplete(true)"
  (cancel)="handleEditComplete(false)"
>
  @if (!!data && data.team !== undefined && data.team !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput [formControl]="teamNameFormControl" placeholder="Name (required)"
              (blur)="saveTeam('name')" value="{{data.team.name}}">
            @if (teamNameFormControl.hasError('required')) {
            <mat-error>
              Name is <strong>required</strong>!
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Short Name</mat-label>
            <input type="text" matInput [formControl]="teamShortNameFormControl" placeholder="Short Name (required)"
              (blur)="saveTeam('shortName')" value="{{data.team.shortName}}">
            @if (teamShortNameFormControl.hasError('required')) {
            <mat-error>
              Short Name is <strong>required</strong>
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" [formControl]="emailFormControl" (blur)="saveTeam('email')"
              value="{{data.team.email}}">
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</crucible-dialog>
